module.exports = {
    CREATE_FALL_PROTECTION: "CREATE_FALL_PROTECTION",
    CREATE_FALL_PROTECTION_REQUEST: "CREATE_FALL_PROTECTION_REQUEST",
    CREATE_FALL_PROTECTION_FAIL: "CREATE_FALL_PROTECTION_FAIL",

    SUBMIT_FALL_PROTECTION: "SUBMIT_FALL_PROTECTION",
    SUBMIT_FALL_PROTECTION_REQUEST: "SUBMIT_FALL_PROTECTION_REQUEST",
    SUBMIT_FALL_PROTECTION_FAIL: "SUBMIT_FALL_PROTECTION_FAIL",

    UPDATE_FALL_PROTECTION: "UPDATE_FALL_PROTECTION",
    UPDATE_FALL_PROTECTION_REQUEST: "UPDATE_FALL_PROTECTION_REQUEST",
    UPDATE_FALL_PROTECTION_FAIL: "UPDATE_FALL_PROTECTION_FAIL",

    SET_FALL_PROTECTION_DRAFT: "SET_FALL_PROTECTION_DRAFT",
    SET_FALL_PROTECTION_DRAFT_REQUEST: "SET_FALL_PROTECTION_DRAFT_REQUEST",
    SET_FALL_PROTECTION_DRAFT_FAIL: "SET_FALL_PROTECTION_DRAFT_FAIL",

    APPROVE_FALL_PROTECTION: "APPROVE_FALL_PROTECTION",
    APPROVE_FALL_PROTECTION_REQUEST: "APPROVE_FALL_PROTECTION_REQUEST",
    APPROVE_FALL_PROTECTION_FAIL: "APPROVE_FALL_PROTECTION_FAIL",   

    REJECT_FALL_PROTECTION: "REJECT_FALL_PROTECTION",
    REJECT_FALL_PROTECTION_REQUEST: "REJECT_FALL_PROTECTION_REQUEST",
    REJECT_FALL_PROTECTION_FAIL: "REJECT_FALL_PROTECTION_FAIL",

    GET_FALL_PROTECTIONS: "GET_FALL_PROTECTIONS",
    GET_FALL_PROTECTIONS_REQUEST: "GET_FALL_PROTECTIONS_REQUEST",
    GET_FALL_PROTECTIONS_FAIL: "GET_FALL_PROTECTIONS_FAIL",

    GET_FALL_PROTECTION: "GET_FALL_PROTECTION",
    GET_FALL_PROTECTION_REQUEST: "GET_FALL_PROTECTION_REQUEST",
    GET_FALL_PROTECTION_FAIL: "GET_FALL_PROTECTION_FAIL",

    GET_FALL_PROTECTIONS_BY_USER: "GET_FALL_PROTECTIONS_BY_USER",
    GET_FALL_PROTECTIONS_BY_USER_REQUEST: "GET_FALL_PROTECTIONS_BY_USER_REQUEST",
    GET_FALL_PROTECTIONS_BY_USER_FAIL: "GET_FALL_PROTECTIONS_BY_USER_FAIL",

    GET_FALL_PROTECTIONS_BY_LOCATION: "GET_FALL_PROTECTIONS_BY_LOCATION",
    GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST: "GET_FALL_PROTECTIONS_BY_LOCATION_REQUEST",
    GET_FALL_PROTECTIONS_BY_LOCATION_FAIL: "GET_FALL_PROTECTIONS_BY_LOCATION_FAIL",

    DELETE_FALL_PROTECTION: "DELETE_FALL_PROTECTION",
    DELETE_FALL_PROTECTION_REQUEST: "DELETE_FALL_PROTECTION_REQUEST",
    DELETE_FALL_PROTECTION_FAIL: "DELETE_FALL_PROTECTION_FAIL",
}